export const password = (value) => /^.{5,}$/.test(value)



// WEBPACK FOOTER //
// ./src/validators/password.js